import * as React from "react";
import {
  AccessorFn,
  ColumnHelper,
  DeepKeys,
  DisplayColumnDef,
  RowData
} from "@tanstack/react-table";
import styled from "styled-components";

import { Text } from "src/library/components/Text";
import { minutesToHHMM } from "src/library/utils/time-helpers/time-helpers";

/**
 * This function returns a reusable formated column definition for time data to be used in Tanstack tables
 *
 * @param columnHelper
 * @param accessor
 * @param column
 * @returns column definition for numerical data, text content example: 01:15
 */
export const timeColumn = <TData extends RowData, TAccessor = AccessorFn<TData> | DeepKeys<TData>>(
  columnHelper: ColumnHelper<TData>,
  accessor: TAccessor,
  column: Partial<Pick<DisplayColumnDef<TData>, "header" | "id" | "enableSorting">>
) => {
  return columnHelper.accessor(accessor as DeepKeys<TData>, {
    id: column.id ? column.id : accessor,
    header: column.header ? column.header.toString() : typeof accessor === "string" ? accessor : "",
    cell: info => (
      <TextValueWrapper>
        <Text>
          {minutesToHHMM(info.getValue() as number)}
        </Text>
      </TextValueWrapper>
    ),
    enableSorting: column.enableSorting,
    minSize: 70,
    meta: { style: { align: "right" } }
  } as DisplayColumnDef<TData>);
};

const TextValueWrapper = styled.div`
  text-align: center;
`;
